//
import WhProductModel from '@/models/Warehouse/WhProduct'

/**
 * This class describes a wh product.
 * @class      WhProduct (name)
 */
export default class WhProduct extends WhProductModel {

  /**
   * Returns a list representation of the object.
   * @return     {Object}  List representation of the object.
   */
  static toList() {
    return this
  }
  
  /**
   * Returns a list representation of the object.
   * @return     {Object}  List representation of the object.
   */
  static toPackList() {

    //
    this.appends = []
    this.includes = ['wh_pack']

    //
    return this
  }
  
  /**
   * Returns a list representation of the object.
   * @return     {Object}  List representation of the object.
   */
  static toListWithSalePrice() {
    this.appends = ['sale_prices']
    return this
  }
}
